import API from '../api'

const Fetcher = url => API.get(url).then(res => res.data)

export default Fetcher